"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnIfURLIsTooLong = exports.tooLongLogger = void 0;
var _constants = require("../constants");
var _logger = require("../logger");
/* istanbul ignore file @preserve --not testable */

const tooLongLogger = exports.tooLongLogger = _logger.mainLogger.createChild('warnIfURLIsTooLong');
const warnIfURLIsTooLong = queryString => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  if (typeof window.location === 'undefined') {
    return;
  }
  const url = new URL(window.location.href);
  url.search = queryString;
  if (url.href.length > _constants.URL_MAX_LENGTH) {
    tooLongLogger.warn("URL is too long, it won't work in some browsers", {
      urlLength: url.href.length
    });
  }
};
exports.warnIfURLIsTooLong = warnIfURLIsTooLong;
